export default __webpack_public_path__ + "9718e1e334649b7d823ea0e6d239cd55.png";